/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AppType = "AGENT_APP" | "BUSINESS_APP" | "BUSINESS_APP_IOS" | "CUSTOMER_APP_ANDROID" | "CUSTOMER_APP_IOS" | "DISTRIBUTOR_APP" | "FIELD_APP" | "INTERNAL_WEB_APP" | "ISSUER_APP" | "KIOSK_APP" | "MERCHANT_APP" | "SUPPORT_WEB_APP" | "UNKNOWN_APP" | "%future added value";
export type MerchantTabQueryVariables = {
    mobile: string;
    around?: string | null | undefined;
    when?: string | null | undefined;
    canReadHistory: boolean;
    canReadBalance: boolean;
};
export type MerchantTabQueryResponse = {
    readonly wallet: {
        readonly user: {
            readonly merchantUser: {
                readonly businessAppVersion: {
                    readonly appType: AppType;
                    readonly appVersionCode: number | null;
                    readonly isUpToDate: boolean;
                    readonly string: string;
                } | null;
            } | null;
            readonly merchant: {
                readonly " $fragmentRefs": FragmentRefs<"MerchantTab_merchant">;
            } | null;
            readonly " $fragmentRefs": FragmentRefs<"EscalateToMerchantSupport_user">;
        } | null;
    } | null;
};
export type MerchantTabQuery = {
    readonly response: MerchantTabQueryResponse;
    readonly variables: MerchantTabQueryVariables;
};



/*
query MerchantTabQuery(
  $mobile: String!
  $around: ID
  $when: DateTime
  $canReadHistory: Boolean!
  $canReadBalance: Boolean!
) {
  wallet(mobile: $mobile) {
    user {
      merchantUser {
        businessAppVersion {
          appType
          appVersionCode
          isUpToDate
          string
        }
      }
      merchant {
        ...MerchantTab_merchant_1I4QzY
        id
      }
      ...EscalateToMerchantSupport_user
      id
    }
    id
  }
}

fragment ChangePayoutRecipient_transfer on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  sender: senderName
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
}

fragment EscalateToMerchantSupport_user on User {
  possibleMerchantIssueTypes {
    type
    displayName
  }
  merchant {
    ufid
    id
  }
}

fragment HistoryEntry_entry on HistoryEntry {
  __isHistoryEntry: __typename
  id
  whenEntered
  amount
  balance
  summary
  isPending
  isCancelled
  ... on SupportHistoryEntry {
    __isSupportHistoryEntry: __typename
    scamInvestigationFields {
      deviceId
      deviceModel
      deviceName
      userInterface
      agentMobile
    }
  }
  ... on AgentTransactionEntry {
    agentTransactionId
  }
  ... on TransferSentEntry {
    transferId
  }
}

fragment MerchantAtxEntry_tx on AgentTransactionEntry {
  agentTransactionId
  isDeposit
  amount
  cashierName: counterpartyNameOnly
  cashierMobile: maybeTerminatedCustomerMobile
  agentId
  agentUfid
  agentName
  subagentId
  subagentName
  subagentUfid
  type
  isCancelled
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...HistoryEntry_entry
}

fragment MerchantHistoryEntry_entry on HistoryEntry {
  __isHistoryEntry: __typename
  __typename
  ...HistoryEntry_entry
  ...MerchantSaleEntry_tx
  ...MerchantTransferSentEntry_tx
  ...MerchantAtxEntry_tx
  ...PayoutTransferEntry_tx
  ...PayoutTransferSentEntry_tx
}

fragment MerchantSaleEntry_tx on MerchantSaleEntry {
  maybeTransferId: transferId
  maybeSenderName: senderName
  maybeSenderMobile: senderMobile
  maybeTerminatedSenderMobile
  qrText
  merchantUName
  actionSource
  isRefunded
  isRemote
  ...HistoryEntry_entry
  ...RefundMerchantSale_transfer
}

fragment MerchantTab_merchant_1I4QzY on Merchant {
  id
  ufid
  name
  city
  region
  subcity
  country
  nearbyLandmark
  isActive
  whenDeactivated
  deactivatedBy
  deactivatedBecause
  photos {
    url
  }
  promotedBy {
    name
    mobile
    id
  }
  activeKybGracePeriod {
    kybTierGranted
  }
  businessNetwork {
    name
    wallets {
      walletId
    }
  }
  ...MerchantUsersList_merchant
  wallet {
    id
    balance @include(if: $canReadBalance)
    name
    mobile
    kybTier
    photoEditUrl
    merchantSupportEscalations {
      whenOpened
      status
      clickupTaskId
    }
    supportHistoryConnection(last: 30, around: $around, when: $when) @include(if: $canReadHistory) {
      edges {
        node {
          __typename
          id
          ... on MerchantSaleEntry {
            maybeTransferId: transferId
          }
          ... on PayoutTransferEntry {
            __typename
            tcid
            amount
            whenEntered
          }
          ...MerchantHistoryEntry_entry
          ... on AgentTransactionEntry {
            agentTransactionId
          }
        }
        cursor
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
}

fragment MerchantTransferSentEntry_tx on TransferSentEntry {
  tx_id: transferId
  sender: senderName
  mobile: senderMobile
  recipientName
  recipientMobile
  maybeTerminatedRecipientMobile
  amount
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...HistoryEntry_entry
  ...RefundP2P_transfer
}

fragment MerchantUsersList_merchant on Merchant {
  principal {
    id
    name
    contactMobile
  }
  assistants {
    id
    name
    mobile
  }
}

fragment PayoutTransferEntry_tx on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  senderName
  recipientMobile
  isReversal
  ...HistoryEntry_entry
  ...SupportPayoutTransferReverse_transfer
  ...ChangePayoutRecipient_transfer
}

fragment PayoutTransferSentEntry_tx on PayoutTransferEntry {
  tcid
  senderOpaqueId
  amount
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
  ...HistoryEntry_entry
  ...SupportPayoutTransferReverse_transfer
  ...ChangePayoutRecipient_transfer
}

fragment RefundMerchantSale_transfer on MerchantSaleEntry {
  id
  maybeTransferId: transferId
  maybeSenderName: senderName
  maybeSenderMobile: senderMobile
  grossAmount
}

fragment RefundP2P_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  sendAmount
  receiveAmount
  senderName
  senderMobile
  recipientName
  maybeTerminatedRecipientMobile
}

fragment SupportPayoutTransferReverse_transfer on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  sender: senderName
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "around"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadBalance"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadHistory"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mobile"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "when"
},
v5 = [
  {
    "kind": "Variable",
    "name": "mobile",
    "variableName": "mobile"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "MerchantUser",
  "kind": "LinkedField",
  "name": "merchantUser",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AppVersion",
      "kind": "LinkedField",
      "name": "businessAppVersion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appVersionCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUpToDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "string",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "kind": "Variable",
  "name": "around",
  "variableName": "around"
},
v8 = {
  "kind": "Variable",
  "name": "when",
  "variableName": "when"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobile",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenOpened",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v15 = [
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "last",
    "value": 30
  },
  (v8/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenEntered",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPending",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCancelled",
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScamInvestigationFields",
      "kind": "LinkedField",
      "name": "scamInvestigationFields",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceModel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userInterface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agentMobile",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SupportHistoryEntry",
  "abstractKey": "__isSupportHistoryEntry"
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentTransactionId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ScamReportTicket",
  "kind": "LinkedField",
  "name": "scamReports",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "whenResolved",
      "storageKey": null
    },
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionIds",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transferId",
  "storageKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/)
  ],
  "type": "TransferSentEntry",
  "abstractKey": null
},
v27 = {
  "alias": "sender",
  "args": null,
  "kind": "ScalarField",
  "name": "senderName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientMobile",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderName",
  "storageKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/)
  ],
  "type": "AgentTransactionEntry",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MerchantTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Wallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Merchant",
                "kind": "LinkedField",
                "name": "merchant",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      (v7/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "canReadBalance",
                        "variableName": "canReadBalance"
                      },
                      {
                        "kind": "Variable",
                        "name": "canReadHistory",
                        "variableName": "canReadHistory"
                      },
                      (v8/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "MerchantTab_merchant"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EscalateToMerchantSupport_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "MerchantTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Wallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Merchant",
                "kind": "LinkedField",
                "name": "merchant",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ufid",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "region",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subcity",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "country",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nearbyLandmark",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "whenDeactivated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deactivatedBy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deactivatedBecause",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MerchantPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "promotedBy",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "KybGracePeriod",
                    "kind": "LinkedField",
                    "name": "activeKybGracePeriod",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "kybTierGranted",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BusinessNetwork",
                    "kind": "LinkedField",
                    "name": "businessNetwork",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BusinessNetworkWallet",
                        "kind": "LinkedField",
                        "name": "wallets",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "walletId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "principal",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contactMobile",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MerchantAssistant",
                    "kind": "LinkedField",
                    "name": "assistants",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Wallet",
                    "kind": "LinkedField",
                    "name": "wallet",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "kybTier",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "photoEditUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MerchantSupportEscalationTicket",
                        "kind": "LinkedField",
                        "name": "merchantSupportEscalations",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "clickupTaskId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "canReadBalance",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "condition": "canReadHistory",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v15/*: any*/),
                            "concreteType": "SupportHistoryConnection",
                            "kind": "LinkedField",
                            "name": "supportHistoryConnection",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SupportHistoryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                      },
                                      (v9/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": "maybeTransferId",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "transferId",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "MerchantSaleEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "tcid",
                                            "storageKey": null
                                          },
                                          (v16/*: any*/),
                                          (v17/*: any*/)
                                        ],
                                        "type": "PayoutTransferEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v17/*: any*/),
                                          (v16/*: any*/),
                                          (v14/*: any*/),
                                          (v18/*: any*/),
                                          (v19/*: any*/),
                                          (v20/*: any*/),
                                          (v21/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v22/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isDeposit",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": "cashierName",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "counterpartyNameOnly",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": "cashierMobile",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "maybeTerminatedCustomerMobile",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "agentId",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "agentUfid",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "agentName",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "subagentId",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "subagentName",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "subagentUfid",
                                                "storageKey": null
                                              },
                                              (v23/*: any*/),
                                              (v24/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v26/*: any*/)
                                                ],
                                                "type": "HistoryEntry",
                                                "abstractKey": "__isHistoryEntry"
                                              }
                                            ],
                                            "type": "AgentTransactionEntry",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v25/*: any*/),
                                              {
                                                "alias": "tx_id",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "transferId",
                                                "storageKey": null
                                              },
                                              (v27/*: any*/),
                                              {
                                                "alias": "mobile",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "senderMobile",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "recipientName",
                                                "storageKey": null
                                              },
                                              (v28/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "maybeTerminatedRecipientMobile",
                                                "storageKey": null
                                              },
                                              (v24/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "sendAmount",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "receiveAmount",
                                                    "storageKey": null
                                                  },
                                                  (v29/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "senderMobile",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "MobileTransferEntry",
                                                "abstractKey": "__isMobileTransferEntry"
                                              }
                                            ],
                                            "type": "TransferSentEntry",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "maybeSenderName",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "senderName",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": "maybeSenderMobile",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "senderMobile",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "maybeTerminatedSenderMobile",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "qrText",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "merchantUName",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "actionSource",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isRefunded",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isRemote",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "grossAmount",
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v17/*: any*/),
                                                  (v16/*: any*/),
                                                  (v14/*: any*/),
                                                  (v18/*: any*/),
                                                  (v19/*: any*/),
                                                  (v20/*: any*/),
                                                  (v21/*: any*/),
                                                  (v30/*: any*/),
                                                  (v26/*: any*/)
                                                ],
                                                "type": "HistoryEntry",
                                                "abstractKey": "__isHistoryEntry"
                                              }
                                            ],
                                            "type": "MerchantSaleEntry",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "senderOpaqueId",
                                                "storageKey": null
                                              },
                                              (v29/*: any*/),
                                              (v28/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isReversal",
                                                "storageKey": null
                                              },
                                              (v27/*: any*/),
                                              {
                                                "alias": "maybeRecipientName",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "recipientName",
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  (v18/*: any*/),
                                                  (v19/*: any*/),
                                                  (v20/*: any*/),
                                                  (v21/*: any*/),
                                                  (v30/*: any*/),
                                                  (v26/*: any*/)
                                                ],
                                                "type": "HistoryEntry",
                                                "abstractKey": "__isHistoryEntry"
                                              }
                                            ],
                                            "type": "PayoutTransferEntry",
                                            "abstractKey": null
                                          }
                                        ],
                                        "type": "HistoryEntry",
                                        "abstractKey": "__isHistoryEntry"
                                      },
                                      (v30/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasPreviousPage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "startCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v15/*: any*/),
                            "filters": [
                              "around",
                              "when"
                            ],
                            "handle": "connection",
                            "key": "MerchantTab_supportHistoryConnection",
                            "kind": "LinkedHandle",
                            "name": "supportHistoryConnection"
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MerchantIssueEntry",
                "kind": "LinkedField",
                "name": "possibleMerchantIssueTypes",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "65db8aaa62581bd232ef187e8fc2b6a5",
    "id": null,
    "metadata": {},
    "name": "MerchantTabQuery",
    "operationKind": "query",
    "text": "query MerchantTabQuery(\n  $mobile: String!\n  $around: ID\n  $when: DateTime\n  $canReadHistory: Boolean!\n  $canReadBalance: Boolean!\n) {\n  wallet(mobile: $mobile) {\n    user {\n      merchantUser {\n        businessAppVersion {\n          appType\n          appVersionCode\n          isUpToDate\n          string\n        }\n      }\n      merchant {\n        ...MerchantTab_merchant_1I4QzY\n        id\n      }\n      ...EscalateToMerchantSupport_user\n      id\n    }\n    id\n  }\n}\n\nfragment ChangePayoutRecipient_transfer on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  sender: senderName\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n}\n\nfragment EscalateToMerchantSupport_user on User {\n  possibleMerchantIssueTypes {\n    type\n    displayName\n  }\n  merchant {\n    ufid\n    id\n  }\n}\n\nfragment HistoryEntry_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  id\n  whenEntered\n  amount\n  balance\n  summary\n  isPending\n  isCancelled\n  ... on SupportHistoryEntry {\n    __isSupportHistoryEntry: __typename\n    scamInvestigationFields {\n      deviceId\n      deviceModel\n      deviceName\n      userInterface\n      agentMobile\n    }\n  }\n  ... on AgentTransactionEntry {\n    agentTransactionId\n  }\n  ... on TransferSentEntry {\n    transferId\n  }\n}\n\nfragment MerchantAtxEntry_tx on AgentTransactionEntry {\n  agentTransactionId\n  isDeposit\n  amount\n  cashierName: counterpartyNameOnly\n  cashierMobile: maybeTerminatedCustomerMobile\n  agentId\n  agentUfid\n  agentName\n  subagentId\n  subagentName\n  subagentUfid\n  type\n  isCancelled\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...HistoryEntry_entry\n}\n\nfragment MerchantHistoryEntry_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  __typename\n  ...HistoryEntry_entry\n  ...MerchantSaleEntry_tx\n  ...MerchantTransferSentEntry_tx\n  ...MerchantAtxEntry_tx\n  ...PayoutTransferEntry_tx\n  ...PayoutTransferSentEntry_tx\n}\n\nfragment MerchantSaleEntry_tx on MerchantSaleEntry {\n  maybeTransferId: transferId\n  maybeSenderName: senderName\n  maybeSenderMobile: senderMobile\n  maybeTerminatedSenderMobile\n  qrText\n  merchantUName\n  actionSource\n  isRefunded\n  isRemote\n  ...HistoryEntry_entry\n  ...RefundMerchantSale_transfer\n}\n\nfragment MerchantTab_merchant_1I4QzY on Merchant {\n  id\n  ufid\n  name\n  city\n  region\n  subcity\n  country\n  nearbyLandmark\n  isActive\n  whenDeactivated\n  deactivatedBy\n  deactivatedBecause\n  photos {\n    url\n  }\n  promotedBy {\n    name\n    mobile\n    id\n  }\n  activeKybGracePeriod {\n    kybTierGranted\n  }\n  businessNetwork {\n    name\n    wallets {\n      walletId\n    }\n  }\n  ...MerchantUsersList_merchant\n  wallet {\n    id\n    balance @include(if: $canReadBalance)\n    name\n    mobile\n    kybTier\n    photoEditUrl\n    merchantSupportEscalations {\n      whenOpened\n      status\n      clickupTaskId\n    }\n    supportHistoryConnection(last: 30, around: $around, when: $when) @include(if: $canReadHistory) {\n      edges {\n        node {\n          __typename\n          id\n          ... on MerchantSaleEntry {\n            maybeTransferId: transferId\n          }\n          ... on PayoutTransferEntry {\n            __typename\n            tcid\n            amount\n            whenEntered\n          }\n          ...MerchantHistoryEntry_entry\n          ... on AgentTransactionEntry {\n            agentTransactionId\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        hasPreviousPage\n        hasNextPage\n        startCursor\n        endCursor\n      }\n    }\n  }\n}\n\nfragment MerchantTransferSentEntry_tx on TransferSentEntry {\n  tx_id: transferId\n  sender: senderName\n  mobile: senderMobile\n  recipientName\n  recipientMobile\n  maybeTerminatedRecipientMobile\n  amount\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...HistoryEntry_entry\n  ...RefundP2P_transfer\n}\n\nfragment MerchantUsersList_merchant on Merchant {\n  principal {\n    id\n    name\n    contactMobile\n  }\n  assistants {\n    id\n    name\n    mobile\n  }\n}\n\nfragment PayoutTransferEntry_tx on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  senderName\n  recipientMobile\n  isReversal\n  ...HistoryEntry_entry\n  ...SupportPayoutTransferReverse_transfer\n  ...ChangePayoutRecipient_transfer\n}\n\nfragment PayoutTransferSentEntry_tx on PayoutTransferEntry {\n  tcid\n  senderOpaqueId\n  amount\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n  ...HistoryEntry_entry\n  ...SupportPayoutTransferReverse_transfer\n  ...ChangePayoutRecipient_transfer\n}\n\nfragment RefundMerchantSale_transfer on MerchantSaleEntry {\n  id\n  maybeTransferId: transferId\n  maybeSenderName: senderName\n  maybeSenderMobile: senderMobile\n  grossAmount\n}\n\nfragment RefundP2P_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  sendAmount\n  receiveAmount\n  senderName\n  senderMobile\n  recipientName\n  maybeTerminatedRecipientMobile\n}\n\nfragment SupportPayoutTransferReverse_transfer on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  sender: senderName\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n}\n"
  }
};
})();
(node as any).hash = '9b9c613c20169ca4d2c7d1dfebb1e43b';
export default node;
